/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Access_Label_KnowledgeInputs */



/**
* | output |
* | --- |
* | "Knowledge space \"{name}\"" |
*
* @param {Agent_Access_Label_KnowledgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_label_knowledge = /** @type {((inputs: Agent_Access_Label_KnowledgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Label_KnowledgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wissensraum „${i?.name}“`)
	return /** @type {LocalizedString} */ (`Knowledge space "${i?.name}"`)
});